import { render, staticRenderFns } from "./AssessmentStudentView.vue?vue&type=template&id=8f14dff2&scoped=true"
import script from "./AssessmentStudentView.vue?vue&type=script&lang=js"
export * from "./AssessmentStudentView.vue?vue&type=script&lang=js"
import style0 from "./AssessmentStudentView.vue?vue&type=style&index=0&id=8f14dff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f14dff2",
  null
  
)

export default component.exports